import { useDecision } from '@optimizely/react-sdk';
import { FeatureFlagType } from 'v2/core/clients/featureFlag/flags';
import { Variation } from 'v2/core/clients/featureFlag/optimizely';
import { FeatureFlagOptions } from 'v2/core/clients/featureFlag/types';
import { QueryStatus } from 'v2/core/repository/edge-server/types';

const useOptimizelyFeatureFlag = (
  fflag: FeatureFlagType,
  options?: FeatureFlagOptions,
): [QueryStatus, boolean] => {
  const [decision, ClientReady, didTimeout] = useDecision(fflag.name, {
    autoUpdate: options?.autoUpdate,
  });
  if (didTimeout) {
    return [QueryStatus.SUCCESS_COMPLETED, fflag.fallback];
  }
  if (!ClientReady) {
    return [QueryStatus.IN_PROGRESS, fflag.fallback];
  }

  return [
    QueryStatus.SUCCESS_COMPLETED,
    decision.variationKey === Variation.On,
  ];
};
export default useOptimizelyFeatureFlag;
